import { AfterViewInit, Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RETURN_URL, TOOL_KEY } from '@hazmatsuite-next/shared';
import { AddressType, LanguageService } from '@hazmatsuite-next/ui';
import { map, Subject, switchMap, take } from 'rxjs';
import { AddressModel } from '../../models/address.model';
import { EditAddressModel } from '../../models/edit-address.model';
import { AddressService } from '../../services/address.service';

@Component({
  selector: 'hazmatsuite-next-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.scss'],
})
export class AddressListComponent implements AfterViewInit {
  private loadAddressSubject = new Subject<void>();

  isEditMode = false;
  loadAddress$ = this.loadAddressSubject.asObservable();
  addressList$ = this.loadAddress$.pipe(
    switchMap(() => {
      return this.addressService.getList();
    })
  );
  countryList$ = this.addressService.getCountries();

  validationTranslations$ = this.languageService.translations$.pipe(map(data => data['ValidationResource']));
  addressListTranslations$ = this.languageService.translations$.pipe(map(data => data['AddressListResource']));
  accountTranslations$ = this.languageService.translations$.pipe(
    map(data => data['AccountResource']),
  );
  editItem: EditAddressModel | null = null;
  type: AddressType;
  showConfirmationModal = false;
  tmpAddress?: AddressModel;

  constructor(
    @Inject(TOOL_KEY) private toolkey: string,
    @Inject(RETURN_URL) private returnUrl: string,
    private route: ActivatedRoute,
    private router: Router,
    private addressService: AddressService,
    private languageService: LanguageService) {
    this.type = route.snapshot.params['type'];
  }

  ngAfterViewInit(): void {
    this.loadAddressSubject.next();
  }


  identify(index: number, item: AddressModel) {
    return item.ID;
  }

  addAddress(): void {
    this.editItem = null;
    this.isEditMode = true;
  }

  editAddress(item: AddressModel): void {
    this.addressService.getAddress(item.ID).pipe(
      take(1)
    ).subscribe((addressItem: EditAddressModel) => {
      this.editItem = addressItem;
      this.isEditMode = true;
    });
  }

  selectAddress(address: AddressModel) {
    this.addressService.selectAddress({
      ...address,
      IsUsedAsShipper: this.type == AddressType.shipper,
      Toolkey: this.toolkey[0],
    }).pipe(
      take(1)
    ).subscribe(() => {
      this.router.navigate([`../../${this.returnUrl}`], { relativeTo: this.route, queryParams: { fetchData: true, type: this.type } });
    });
  }

  editCallback(): void {
    this.addressList$ = this.addressService.getList();
    this.isEditMode = false;
  }

}
